// extracted by mini-css-extract-plugin
export default {"pageTitle":"Export_pageTitle__YajIc"};